// |-- Built-in Dependencies --|
import React, { useState, useEffect } from "react";

// |-- External Dependencies --|
import { useDispatch, useSelector } from "react-redux";

// |-- Internal Dependencies --|
import DispositionLevelOneListing from "./DispositionLevelOneListing";
import AddDispositionLevelOneFormWrapper from "../Add/AddDispositionLevelOneFormWrapper";

// |-- Redux --|
import { AppDispatch, RootState } from "src/redux/store";
import { useGetDispositionLevelOneQuery } from "src/services/DispositionLevelOneServices";
import { setItems } from "src/redux/slices/DispositionLevelOneSlice";
import { DispositionLevelOneListResponse } from "src/models/DispositionLevelOne.model";

const DispositionLevelOneListingWrapper = () => {
  const [isOpenAddForm, setIsOpenAddForm] = useState(false);

  const { items, searchValue }: any = useSelector(
    (state: RootState) => state.dispositionLevelOne
  );
  const { data, isLoading, isFetching } = useGetDispositionLevelOneQuery({
    limit: 500,
    searchValue: searchValue,
    params: ["dispositionFirstName"],
    page: 0,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
  });
  const dispatch = useDispatch<AppDispatch>();

  const contries = items?.map((ele: DispositionLevelOneListResponse) => {
    return {
      label: ele.dispositionFirstName,
      value: ele._id,
    };
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      dispatch(setItems(data?.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  return (
    <>
      <DispositionLevelOneListing
        contries={contries}
        items={contries}
        onAddNew={() => setIsOpenAddForm(true)}
      />
      {isOpenAddForm ? (
        <AddDispositionLevelOneFormWrapper
          onClose={() => setIsOpenAddForm(false)}
        />
      ) : null}
    </>
  );
};

export default DispositionLevelOneListingWrapper;
